// extracted by mini-css-extract-plugin
export default {"title":"_90e5d00d50","bld":"_03c501b94d"};